var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChangeRequestIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 14.333L4 12.333H1.33333C0.966667 12.333 0.652667 12.2026 0.391333 11.9417C0.130444 11.6803 0 11.3663 0 10.9997V1.66634C0 1.29967 0.130444 0.985674 0.391333 0.724341C0.652667 0.463452 0.966667 0.333008 1.33333 0.333008H10.6667C11.0333 0.333008 11.3473 0.463452 11.6087 0.724341C11.8696 0.985674 12 1.29967 12 1.66634V10.9997C12 11.3663 11.8696 11.6803 11.6087 11.9417C11.3473 12.2026 11.0333 12.333 10.6667 12.333H8L6 14.333ZM1.33333 10.9997H4.53333L6 12.4663L7.46667 10.9997H10.6667V1.66634H1.33333V10.9997ZM1.33333 1.66634V10.9997V1.66634ZM7.03333 7.36634L9.33333 6.33301L7.03333 5.29967L6 2.99967L4.96667 5.29967L2.66667 6.33301L4.96667 7.36634L6 9.66634L7.03333 7.36634Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeRequestIcon);
export default __webpack_public_path__ + "static/media/change-request-icon.7c983d9a25060f136f605d6440392c42.svg";
export { ForwardRef as ReactComponent };